import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AppContextProvider from 'context/app-context/AppContext';

const rootElement = document.getElementById('root');

ReactDOM.render(
	<BrowserRouter>
		<AppContextProvider>
			<App />
		</AppContextProvider>
	</BrowserRouter>,
	rootElement,
);
